// extracted by mini-css-extract-plugin
export var alternate = "_1m-j";
export var black = "_1m-6";
export var blue = "_1m-f";
export var blueLight = "_1m-e";
export var brand = "_1m-8";
export var darkMode = "_1m-b";
export var error = "_1m-a";
export var gray = "_1m-5";
export var grayBlue = "_1m-d";
export var iconWrapper = "_1m-3";
export var inactive = "_1m-7";
export var indigo = "_1m-g";
export var orange = "_1m-i";
export var pink = "_1m-h";
export var primary = "_1m-0";
export var purple = "_1m-9";
export var success = "_1m-4";
export var warning = "_1m-c";
export var white = "_1m-1";
export var whiteSuccess = "_1m-2";